module.exports = __webpack_public_path__ + "static/media/laptop-code.fd7664fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laptop-code.jpg
// module id = 90
// module chunks = 0